module.exports = __webpack_public_path__ + "img/194.49ae31ce.jpg";